// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

// components
import BaseSelectedIcon from 'shared/styles/assets/icons/components/IconSelected';

export const Container = styled.div<{ isSelected: boolean }>`
  border-radius: ${({ theme }) => theme.borders.radius10};
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.textOutline};
  margin-right: ${({ theme }) => theme.spacing.spacing40};
  position: relative;
  border-color: ${(props) =>
    props.isSelected ? props.theme.colors.textPrimary : props.theme.colors.textOutline};
  line-height: 0;
  flex: none;
  height: calc(20vw * 4 / 3);
  width: 20vw;
  :last-of-type {
    margin-right: 0;
  }

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    cursor: pointer;
  }
`;

export const SelectedOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.textOutline};
  width: 100%;
  height: 100%;
`;

export const SelectedIcon = styled(BaseSelectedIcon)`
  position: absolute;
  top: 0;
  right: 0;
`;

export const OutOfStock = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  padding-top: ${({ theme }) => theme.spacing.spacing20};
  text-transform: capitalize;
  margin: 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.textSecondary};
  backdrop-filter: blur(10px);
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => theme.typography.bodyXSmall};
`;
